<template>
    <v-card class="pa-3" elevation="12" v-if="superUser || permission" :value="$route.path">
        <v-row class="d-flex justify-center">
            <v-col cols="12" md="6" sm="12">
                <v-card elevation="12">
                    <ApiToken elevation="12"/>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import ApiToken from "@/components/loyaltyPanel/businessProfile/ApiToken.vue";

export default {
    name: "ApiKeys",

    components: { ApiToken },

    data() {
        return {};
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "panelType",
            "permissions"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        dateLang() {
            let lang = "en-US";
            if (this.lang === "el") {
                lang = "el-GR";
            } else if (this.lang === "it") {
                lang = "it-IT";
            }
            return lang;
        },
        permission() {
            return (
                this.superUser ||
                (this.permissions
                    ? this.permissions.developers?.api_keys.read
                    : null)
            );
        }
    },

    watch: {
        permission: {
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/${this.panelType}/forbidden-gateway`
                    );
                }
            }
        }
    }
  
};
</script>
